import { mergeClasses } from '@fluentui/react-components';
import { px } from '@this/app-shared/dist/tools/styles.js';
import type { ReactNode } from 'react';
import { COLUMN_SIZE, COLUMN_SIZE_THIN } from '../shared.js';
import { useStyles } from './styles.js';

type PackedGridProps = {
    children: ReactNode;
    autoFit?: boolean;
    compact?: boolean;
};

export function PackedGrid({ children, autoFit, compact }: PackedGridProps) {
    const styles = useStyles();

    const algorithm = autoFit ? 'auto-fit' : 'auto-fill';
    const size = compact ? COLUMN_SIZE_THIN : COLUMN_SIZE;

    return (
        <div
            className={mergeClasses(styles.packedGroup, !!compact && styles.packedGroupCompact)}
            style={{
                gridTemplateColumns: `repeat(${algorithm}, minmax(${px(size)}, 1fr)`,
            }}
        >
            {children}
        </div>
    );
}
